// Style
import "./App.scss";

// Libraries
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import { useEffect, useState } from "react";

// Components
import Home from "./views/Home/Home";
import ErrorPage from "./views/ErrorPage/ErrorPage";
import LevelUno from "./views/LevelUno/LevelUno";
import LevelDos from "./views/LevelDos/LevelDos"; // Core
import LevelCuatro from "./views/LevelCuatro"; // Charge
import LevelTres from "./views/LevelTres/LevelTres"; // Compass
import LevelCinco from "./views/LevelCinco/LevelCinco"; // Vicinus
import LevelSiete from "./views/LevelSiete/LevelSiete"; // Edges
import LevelNueve from "./views/LevelNueve/LevelNueve"; // Pesca
import LevelDiez from "./views/LevelDiez/LevelDiez"; // Center
import LevelSeis from "./views/LevelSeis"; // Emit
import LevelOcho from "./views/LevelOcho"; // Hangman
import GameEnd from "./views/GameEnd";
import LevelOne from "./views/LevelOne";
import LevelThree from "./views/LevelThree";
import LevelSeven from "./views/LevelSeven";

// ORDER:
// Core(dos) Pesca(nueve) Hangman(ocho) Emit(Seis) Center(diez) Compass(tres) Vicinus(cinco) Charge(cuatro) Edges(siete)

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { GC } from './services/config/gameCenteService';
import { storage } from "./services/config/storage";
import { NEW_DATA_EVENT } from "./utils/consts";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

function App() {

  const [gameDetails, setGameDetails] = useState(null);
  const gameInIframe = (window.location !== window.parent.location);

  const syncData = () => {
    const getGameDetails = storage.get.gameDetails();
    setGameDetails(getGameDetails);
  };

  const handleBlur = () => {
    GC.sendGameBlurredMessage()
  }

  useEffect(() => {
    if (!gameInIframe) {
      // Not calling gamecenter apis if not loaded in it.
      return;
    }
    // Adding timeout to handle React.18 intentinonal re-render on development
    const timeout = setTimeout(() => {
      window.addEventListener("message", GC.messageEventHandler);
      GC.sendGameLoadMessage();
    }, 0);
    window.addEventListener(NEW_DATA_EVENT, syncData);
    window.addEventListener("blur", handleBlur)

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("message", GC.messageEventHandler);
      window.removeEventListener(NEW_DATA_EVENT, syncData);
      window.removeEventListener("blur", handleBlur)
    };
  }, []);
  /**  
   *  Render game if any two conditions met 
   *  @param {boolean} gameInIframe - Check game window loaded in iframe to call/not call GC/SDK apis
   *  @param {object} gameDetails - (When game loaded in iframe) Make GC/SDK apis call and set gameData/gameDetails,
   *  which dispatch a window NEW_DATA_EVENT, which sets gameDetails { orgName, mediaUrl, gameName } 
  */
  return (
    <Sentry.ErrorBoundary
      onError={(err) => console.log(err)}
      fallback={<p>An error has occurred</p>}
    >
      <div className="App">
        {
          ((!gameInIframe) || (gameDetails)) &&
          <Router basename="/clearberry">
            <Switch>
              <Route path="/home" component={Home} />
              <Route path="/1" component={LevelOne} />
              <Route path="/3" component={LevelThree} />
              <Route path="/7" component={LevelSeven} />
              <Route path="/level-uno" component={LevelUno} />
              <Route path="/level-dos" component={LevelDos} />
              <Route path="/level-tres" component={LevelTres} />
              <Route path="/level-cuatro" component={LevelCuatro} />
              <Route path="/level-cinco" component={LevelCinco} />
              <Route path="/level-seis" component={LevelSeis} />
              <Route path="/level-siete" component={LevelSiete} />
              <Route path="/level-nueve" component={LevelNueve} />
              <Route path="/level-diez" component={LevelDiez} />
              <Route path="/level-ocho" component={LevelOcho} />
              <Route path="/game-end" component={GameEnd} />
              <Route path="/404" component={ErrorPage} />
              <Route path="/" render={() => <Redirect to="/home" />} />
              <Route render={() => <Redirect to="/404" />} />
            </Switch>
          </Router>
        }
      </div>
    </Sentry.ErrorBoundary>
  );
}

export default App;
